module.exports = function checkDuplicatedTransaction({ client, baseUrl, payerId }) {
  return function (data, cb) {
    return client.executeRequest('POST', `${baseUrl}/${payerId}/duplicatetranscheck`, {
      cb,
      data,
      returnModel: {
        name: 'duplicatetranscheck',
      },
    });
  };
}